import { apiClient } from "./api-client";

export interface InferenceRequestBody {
  patientId: string;
  strategy: "generic" | "contextual" | "structured" | "few-shot" | "dynamic";
  context?: Record<string, unknown>;
  provider?: "gemini" | "openai" | "auto";
  model?: string;
  temperature?: number;
}

export interface InferenceResponse {
  success: boolean;
  id: string;
  patientId: string;
  strategy: string;
  provider: string;
  model: string;
  result: {
    content: string;
    promptTokens: number;
    completionTokens: number;
    latencyMs: number;
    costUsd: number;
  };
  metadata: {
    createdAt: string;
  };
}

export function runInference(
  payload: InferenceRequestBody,
  signal?: AbortSignal,
): Promise<InferenceResponse> {
  return apiClient<InferenceResponse>("/inference/run", {
    method: "POST",
    body: payload,
    signal,
  });
}
